var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalanceSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 16",
    style: {
      enableBackground: "new 0 0 15 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.balance-sheet-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "balance-sheet-svg",
    d: "M8.8,0.8h-5c-1.1,0-2,0.9-2,2v3.5 M8.8,0.8v3.5c0,1.1,0.9,2,2,2h3.5 M8.8,0.8l5.5,5.5 M14.2,6.2v7 c0,1.1-0.9,2-2,2H8.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "balance-sheet-svg",
    d: "M5.2,8.8H4.8c-1.7,0-3,1.3-3,3v0.5c0,1.7,1.3,3,3,3h0.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "balance-sheet-svg",
    d: "M0.8,12h3.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceSheet);
export default __webpack_public_path__ + "static/media/balance-sheet.2705e6f4c1062de17062434f2745c03c.svg";
export { ForwardRef as ReactComponent };